module.exports = require("os");


//////////////////
// WEBPACK FOOTER
// external "os"
// module id = 7
// module chunks = 0 1